export function handleValidation(
  type: string,
  value: string,
): string | undefined {
  let validation;
  switch (type) {
    case "Temail":
      validation = isValidEmail(value);
      break;
/*     case "password":
      validation = isValidPassword(value);
      break; */
    default:
      validation = undefined;
      break;
  }
  return validation;
}

export function isValidEmail(email: string): string | undefined {
  const validate =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email || "",
    );
  return validate ? undefined : "Ingrese un email valido";
}

export function isValidPassword(password: string): string | undefined {
  const validate =
  // Controla que minimo tenga 8 caracteres (minimo 1 mayuscula y 1 minuscula). No acepta espacios vacios 
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([A-Za-z\d]|[^ ]){8,}$/.test(
      password || "",
    );
  return validate ? undefined : "Ingrese una contraseña valida";
}
